import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Popup from '@SiteComponents/Popup'
import Button from '@SiteComponents/Button'

import {
  getCurrentWorkspaceId,
} from '@SiteModules/Workspace/selectors'

import {
  getLoading,
  getSelectedIds,
} from '@SiteModules/SpeakerVoice/selectors'

import {
  getEditingSpeakerVoiceIds,
} from '@SiteModules/Popup/selectors'

import {
  removeSpeakerVoicesFromWorkspace,
} from '@SiteModules/SpeakerVoice/actions'

import {
  closeVoiceStudioPopups,
} from '@SiteModules/Popup/actions'

import AttentionIcon from '@Images/attention.svg'

import './RemoveSpeakerVoicePopup.scss'

interface RemoveSpeakerVoicePopupProps {
  closePopup(): void
}

const RemoveSpeakerVoicePopup: React.FC<RemoveSpeakerVoicePopupProps> = (props) => {
  const dispatch = useDispatch()

  const currentWorkspaceId = useSelector(getCurrentWorkspaceId)
  const loading = useSelector(getLoading)
  let speakerVoiceIds = useSelector(getEditingSpeakerVoiceIds)
  if (speakerVoiceIds.length === 0) {
    speakerVoiceIds = useSelector(getSelectedIds)
  }
  const [removeConfirmation, setRemoveConfirmation] = useState('')

  const canRemove = removeConfirmation === 'remove' || removeConfirmation === 'REMOVE'
  const shouldDisableButton = !canRemove || loading

  const changeRemoveConfirmation = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRemoveConfirmation(e.target.value)
  }

  const handleConfirm = () => {
    if (canRemove) {
      dispatch(removeSpeakerVoicesFromWorkspace({ workspaceId: currentWorkspaceId, speakerVoiceIds }))
      dispatch(closeVoiceStudioPopups())
    }
  }

  return (
    <Popup
      className="RemoveSpeakerVoicePopup"
      closePopup={props.closePopup}
    >
      <div className="RemoveSpeakerVoicePopup__title">Remove the voice(s)</div>
      <p className="RemoveSpeakerVoicePopup__description">
        <AttentionIcon className="RemoveSpeakerVoicePopup__description__icon" />
        Warning, you will remove the selected voice(s).<br />
        If their source projects are deleted, they will be permanently lost.
      </p>
      <p className="RemoveSpeakerVoicePopup__description">
        Type “remove” below to validate this action.
      </p>

      <input className="RemoveSpeakerVoicePopup__confirmation"
        placeholder="remove"
        value={removeConfirmation}
        onChange={changeRemoveConfirmation}
      />

      <Button
        styleType="brand"
        size="large"
        caption="Confirm the action"
        onClick={handleConfirm}
        disabled={shouldDisableButton}
      />
    </Popup>
  )
}

export default RemoveSpeakerVoicePopup
